<template>
  <section :class="$style.wrapper">
    <header :class="$style.header">
      <h2 :class="$style.title">チームを追加</h2>
      <ButtonClose @click="emit('close')" />
    </header>
    <section :class="$style.body">
      <div :class="$style.action">
        <TeamTitle
          :class="$style.action__selector"
          :teamName="teamName"
          @update="updateTeamName"
        />
        <FlatButton
          :class="$style.action__button"
          @click="handleCreateTeam"
          :disabled="!isValid"
        >
          追加
        </FlatButton>
      </div>
    </section>
  </section>
</template>

<script lang="ts" setup>
import TeamTitle from '@/components/organisms/TeamManagementForm/TeamTitle.vue'
import { ref, computed } from 'vue'
import ButtonClose from '@/components/atoms/ButtonClose.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'

const emit = defineEmits<{
  close: []
  createTeam: [teamName: string]
}>()

const teamName = ref('')
const isValid = computed(() => teamName.value.trim().length > 0)

const updateTeamName = (name: string) => {
  teamName.value = name
}

const handleCreateTeam = () => {
  if (!isValid.value) return

  emit('createTeam', teamName.value.trim())
  teamName.value = ''
}
</script>

<style lang="scss" module>
.wrapper {
  width: 90vw;
  max-width: 620px;
}

.header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid $color-border-low-emphasis;
}

.title {
  font-size: 16px;
  font-weight: bold;
}

.body {
  padding: 10px 40px 40px;

  &__buttonWrapper {
    margin-top: 44px;
  }
}

.table {
  width: 100%;
}

.action {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;

  &__selector {
    flex-grow: 1;
    width: 50%;
  }

  &__button {
    flex-grow: 0;
    white-space: nowrap;
    display: block;
  }
}

.empty {
  margin-top: 10px;
}
</style>
